/* eslint-disable eqeqeq */
import http from '../../Utils/http';

const Theme = {
  name: 'gridDialog',
  state: {
    open: false,
    rateOpen: false,
    data: '',
  },
  reducers: {
    openDialog(state, payload) {
      return { ...state, open: payload };
    },
    rateOpenDialog(state, payload) {
      return { ...state, rateOpen: payload };
    },
    received(state, payload) {
      return { ...state, data: payload };
    },
  },
  effects: (dispatch) => ({
    async openDialogFunction(data) {
      const org_id = JSON.parse(localStorage.getItem('userInfo')).org_id;
      const response = await http.get(
        `savvy/displays/get-display-for-edit/${data.id}?org_id=${org_id}`
      );
      await this.received(response.data.data);
      this.openDialog(data.open);
    },
    async openDialogRateScheduleFunction(data) {
      const Id = data.id;
      const response = await http.get(`savvy/rate-schedule/${Id}`);
      await Promise.all(response?.data?.data?.zones?.map(async (zone) => {
        const rateResponse = await http.get(`savvy/rate-schedule/zone/${zone.id}`);
        zone['rateDetails'] = rateResponse.data.data;
      }))
      
      await this.received(response.data.data);
      this.rateOpenDialog(data.open);
    },
  }),
};

export default Theme;
